import { Amount } from "./Amount";
import { WidgetProps } from "./types";
import { useListMeter } from "../services/projectApi";
import { useAuth } from "../Providers";
import moment from "moment";


const OfflineSummary: React.FC<WidgetProps> = (props) => {

  const { } = props;

  const auth = useAuth();
  const param: object = {
    accountId: auth.account?.accountid,
    onlineStatus: 0,
  };
  const {
    data: meterNodes,
  } = useListMeter(param);

  const timestamp = moment().format("YYYY -MM-DD HH:mm:ss");
  const totalMeters = parseInt(process.env.REACT_APP_TOTAL_METERS || "0", 10);
  const maxOfflineMeters = parseFloat(process.env.REACT_APP_MAX_OFF_PERCENTAGE || "0");

  return (

    <div className='chart amount-wrap amount-wrap-horizontal'>
      <Amount
        title="Current Number of Offline meter"
        value={meterNodes?.length?.toString() || "0"}
        unit="Units"
        supplement={`Timestamp: ${timestamp}`}
      />
      <Amount
        title="Current Percentage of Offline meter"
        value={((meterNodes?.length || 0) / totalMeters * 100).toFixed(2) || "0"}
        unit="percent"
        supplement={`Timestamp: ${timestamp}`}

      />
      <Amount
        title="Maximum Number of Offline meter"
        value={(Math.ceil(totalMeters * maxOfflineMeters)).toString() || "0"}
        unit="Units"
        supplement={`From ${totalMeters} units`}

      />
    </div>

  )
}

export default OfflineSummary;